var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeCompanyDirectionMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5351562,17.1210938L26.4140625,1C25.125-0.2890625,22.875-0.2890625,21.5859375,1L5.4648438,17.1210938 C4.5205078,18.0654297,4,19.3212891,4,20.6572266V43c0,1.6542969,1.3457031,3,3,3h10c1.6542969,0,3-1.3457031,3-3V31 c0-0.5517578,0.4482422-1,1-1h6c0.5517578,0,1,0.4482422,1,1v12c0,1.6542969,1.3457031,3,3,3h10c1.6542969,0,3-1.3457031,3-3 V20.6572266C44,19.3212891,43.4794922,18.0654297,42.5351562,17.1210938z M42,43c0,0.5517578-0.4482422,1-1,1H31 c-0.5517578,0-1-0.4482422-1-1V31c0-1.6542969-1.3457031-3-3-3h-6c-1.6542969,0-3,1.3457031-3,3v12c0,0.5517578-0.4482422,1-1,1H7 c-0.5517578,0-1-0.4482422-1-1V20.6572266c0-0.8017578,0.3124962-1.5556641,0.8789062-2.1220703L23,2.4140625 c0.5351562-0.5332031,1.4648438-0.5332031,2,0l16.1210938,16.1210938C41.6874962,19.1015625,42,19.8554688,42,20.6572266V43z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCompanyDirectionMedium);
export default __webpack_public_path__ + "static/media/home-company-direction--medium.17646fa000bb7cd2cef0d620b111c68e.svg";
export { ForwardRef as ReactComponent };